module.exports = __webpack_public_path__ + "media/LogON.b6841f0a.mp3";